module.exports = __webpack_public_path__ + "img/img15.571c7c90.png";